import { defaultInstance } from "../../instances/default.instance";

/**
 * @param {string?} type
 * @param {string?} clientId
 * @param {string?} employeeId
 * @param {AbortSignal?} signal
 * @returns {Promise<Array<Record>>}
 */
export const getInvoices = (type, clientId, employeeId, signal) => {
	const params = new URLSearchParams();
	if (type) params.append("type", type);
	if (clientId) params.append("clientId", clientId);
	if (employeeId) params.append("employeeId", employeeId);

	return defaultInstance({
		method: "GET",
		url: `/invoices/getAll?${params.toString()}`,
		signal,
	});
};

export const createTag = (encodedID,isUpdatingFollowup,followupComment,tagType,signal) => {
	return defaultInstance({
	method: "PUT",
	url: `/invoices/followup?invoiceID=${encodedID}&isUpdatingFollowup=${isUpdatingFollowup}`,
    data: {
        followupComment,
        tagType,
    },
    signal,
	});
};
/**
 * @returns {Promise<Array<Record>>}
*/
export const getInvoicesDefaulters = ({
	clientID = "",
	employeeID = "",
}) => {
	return defaultInstance({
		method: "GET",
		url: `/invoices/getInvoicesDefaulters?clientID=${clientID}&employeeID=${employeeID}`,
	});
}

export const getTagsData = () => {
	console.log('call done')
	return defaultInstance({
		method: "GET",
		url: `/invoices/tagsData`,
	});
};

export const getTagsTable = (branch,signal) => {
	console.log('branch call done')
	return defaultInstance({
		method: "GET",
		url: `/invoices/tagsTableData?branch=${branch}`,
		signal,
	});
};